// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"722":"9e962f7a","771":"f18fbffe"}[chunkId] + ".chunk.css";
};